import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

// Initialize Firebase
var config = {
  apiKey: "AIzaSyDJrXCfcFBGNm7XBxYlC_lnsJz_kCHg1MY",
  authDomain: "idealkpi-aca59.firebaseapp.com",
  databaseURL: "https://idealkpi-aca59.firebaseio.com",
  projectId: "idealkpi-aca59",
  storageBucket: "",
  messagingSenderId: "445620736615"
};
firebase.initializeApp(config);

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser

// date issue fix according to firebase
db.settings({ timestampsInSnapshots: true })

// firebase collections
const usersCollection = db.collection('users')
const rapportsCollection = db.collection('rapports')

export default {
    db,
    auth,
    currentUser,
    usersCollection,
    rapportsCollection
}